const getMessages = () => {
    const flattenObject = (obj = {}) => {
        const result = {};

        const flatten = (collection, prefix = '', suffix = '') => {
            angular.forEach(collection, (value, key) => {
                const path = `${prefix}${key}${suffix}`;

                if (angular.isArray(value)) {
                    flatten(value, `${path}[`, ']');
                } else if (angular.isObject(value)) {
                    flatten(value, `${path}.`);
                } else {
                    result[path] = value;
                }
            });
        };

        flatten(obj);

        return result;
    };

    const translations = {
        en: flattenObject({
            chat: {
                video: {
                    waiting: "Waiting for {{ firstName }} to Join",
                    stop: "STOP"
                },
                text: {
                    typing: "is typing...",
                    invite: {
                        coach: "Invite as Coach",
                        client: "Invite as Client",
                        liveWorkout: "Live Workout ($)"
                    },
                    invitation: {
                        live: {
                            request: {
                                header: "Live Workout",
                                title: "Invitation to Live Workout",
                                waitingForApproval: "Waiting For Approval",
                                accept: "Accept",
                                reject: "Decline",
                                expiresIn: "Expires In",
                                footer: "Expired"
                            },
                            accepted: {
                                header: "Live Workout",
                                body: "JOIN WORKOUT",
                                footer: "Expired"
                            },
                            rejected: {
                                header: "Live Workout",
                                body: "REJECTED"
                            },
                            ended: {
                                header: "Live Workout",
                                body: "Stopped Live Workout Session"
                            },
                        }
                    },
                    unsupported: "Message Not Supported.",
                    send: "SEND"
                },

            },
            modal: {
                coachImageForm: {
                    selectValidFile: "Please select a valid Image file.",
                    notSuppportHTML5: "This browser does not support HTML5.",
                    imageMust1080: "Image resolution must be at least 1080px",
                    notExceed: "Height and Width must not exceed 2000px."
                },
                btn: {
                    close: "CLOSE",
                    cancel: "CANCEL",
                    copyLink: "Copy link"
                },
                needLogin: {
                    desc: "You must login to access this feature.",
                    redirect_link: 'https://studiogym.com/login',
                    login: "Login"
                },
                needPremium: {
                    youMustHave: "You must subscribe to access this feature.",
                    subscribe: "Subscribe",
                    redirect_link: "https://w.studiogym.com/subscription-plan/",
                },
                clientSelect: {
                    title: "SELECT CUSTOMER",
                    btn: "ASSIGN"
                },
                shareLink: {
                    shareALink: "Share a link",
                    details: "Anyone with this link can view this coach profile."
                },
                orderSelect: {
                    title: "SELECT PENDING ORDER",
                    confirm: "CONFIRM",
                    cancel: "CANCEL",
                    notFound: "You don't have any orders."
                },
                sendOffer: {
                    title: "THERE IS NO PENDIND ORDER FOR",
                    sendAOffer: "SEND A OFFER",
                    priceInUsd: "Price in US dollars",
                    description: "Add a description or detail of you proposition",
                    sendBtn: "SEND PROPOSITION",
                    cancel: "CANCEL",
                    accept: "ACCEPT",
                    decline: "DECLINE",
                    accepted: "ACCEPTED",
                    declined: "DECLINED",
                    backToprofile: "BACK TO PROFIL",
                    seeTheProgram: "SEE THE PROGRAM",
                    success: "Offer send successfully!",
                    hasAssignedYou: "has assigned you a program and need your approbation"
                },
                orderComplete: {
                    title: "PROGRAM ASSIGNED",
                    success: "Program assigned successfully to order!",
                    close: "CLOSE",
                },
                refund: {
                    title: "CANCEL & REFUND",
                    from: "From",
                    cancel: "CANCEL",
                    line1: "You have decided to not deliver or produce",
                    line2: "the workout program order.",
                    line3: "A message and a refund will be sent to the client.",
                    line4: "Please write the reason for the refusal. This message will be attached to the email that will be sent.",
                    confirmRefund: "COMFIRM REFUND",
                    confirmRefundLine2: ""
                },
                inviteCoach: {
                    heading: "INVITE AS COACH",
                    line1: "By inviting {{ name }}",
                    line2: "as your Coach you will provide access",
                    line3: "to your Studiogym profile page:",
                    line4: "Your objective, Workout session information",
                    line5: "Name, Age, Gender, Weigh, Language, Time Zone",
                    button: {
                        confirm: "CONFIRM",
                        cancel: "CANCEL"
                    }
                },
                editPicture: {
                    title: "Picture",
                    label: {
                        chooseFile: "Choose File",
                    },
                    helpText: {
                        image: "Image in square format. Maximum 2000 pixels wide."
                    },
                    button: {
                        save: "SAVE"
                    }
                },
                liveWorkout: {
                    title: "Live Workout",
                    label: {
                        bundleTitle: "Bundle Title",
                        bundleHour: "Bundle Hour",
                        bundlePrice: "Bundle Price",
                        pricePerProgram: "Price Per Program",
                        currency: "Currency",
                        description: "Description",
                        visible: "Visible",
                    },
                    helpText: {
                        description: "Maximum 200 characters"
                    },
                    button: {
                        'erase': "Erase",
                        'save': "Save"
                    }
                },
                personalForm: {
                    title: "Personal Details",
                    label: {
                        "name": "Name",
                        "en": "English",
                        "fr": "French",
                        "title": "Title",
                        "language": "Language",
                        "country": "Country",
                        "timeZone": "Time Zone",
                        "profession": "Profession",
                        "specialities": "Specialities",
                        "qualifications": "Qualifications",
                    },
                    placeholder: {
                        other: "Other"
                    },
                    button: {
                        save: "Save"
                    }
                },
                presentationForm: {
                    title: "Presentation",
                    label: {
                        chooseFile: "Choose File",
                        picture: "Picture",
                        video: "URL",
                        description: "Text",
                    },
                    helpText: {
                        picture: "Image in landscape orientation. Maximum 2000 pixels wide.",
                        video1: "Video URLs from YouTube and Vimeo are supported.",
                        video2: "Files from your computer or device cannot be imported directly.",
                        description: 'Maximum 500 characters'
                    },
                    button: {
                        save: "SAVE"
                    }
                },
                program: {
                    title: "PERSONNALISED PROGRAM",
                    label: {
                        bundleTitle: "Sub Title",
                        pricePerProgram: "Price Per Program",
                        currency: "Currency",
                        description: "Description",
                        visible: "Visible",
                    },
                    helpText: {
                        description: "Maximum 200 characters"
                    },
                    button: {
                        'erase': "Erase",
                        'save': "Save"
                    }
                },
                socialForm: {
                    title: "Social",
                    button: {
                        save: "SAVE"
                    }
                }
            },
            gender: {
                F: "Women",
                M: "Men",
                A: "For all"
            }
        }),
        fr: flattenObject({
            chat: {
                video: {
                    waiting: "Waiting for {{ firstName }} to Join",
                    stop: "STOP"
                },
                text: {
                    typing: "is typing...",
                    invite: {
                        coach: "Invite as Coach",
                        client: "Invite as Client",
                        liveWorkout: "Live Workout ($)"
                    },
                    invitation: {
                        live: {
                            request: {
                                header: "Live Workout",
                                title: "Invitation to Live Workout",
                                waitingForApproval: "Waiting For Approval",
                                accept: "Accept",
                                reject: "Decline",
                                expiresIn: "Expires In",
                                footer: "Expired"
                            },
                            accepted: {
                                header: "Live Workout",
                                body: "JOIN WORKOUT",
                                footer: "Expired"
                            },
                            rejected: {
                                header: "Live Workout",
                                body: "REJECTED"
                            },
                            ended: {
                                header: "Live Workout",
                                body: "Stopped Live Workout Session"
                            },
                        }
                    },
                    unsupported: "Message Not Supported.",
                    send: "SEND"
                },

            },
            modal: {
                coachImageForm: {
                    selectValidFile: "Please select a valid Image file.",
                    notSuppportHTML5: "This browser does not support HTML5.",
                    imageMust1080: "Image resolution must be at least 1080px",
                    notExceed: "Height and Width must not exceed 2000px."
                },
                btn: {
                    close: "CLOSE",
                    cancel: "CANCEL",
                    copyLink: "Copy link"
                },
                needLogin: {
                    desc: "Vous devez être connecté.",
                    redirect_link: 'https://studiogym.com/login',
                    login: "S'identifier"
                },
                needPremium: {
                    youMustHave: "Vous devez être abonné pour accéder à cette fonctionnalité.",
                    subscribe: "Abonnez-vous",
                    redirect_link: "https://w.studiogym.com/subscription-plan/",
                },
                clientSelect: {
                    title: "SELECT CUSTOMER",
                    btn: "ASSIGN"
                },
                shareLink: {
                    shareALink: "Share a link",
                    details: "Anyone with this link can view this coach profile."
                },
                orderSelect: {
                    title: "SELECT PENDING ORDER",
                    confirm: "CONFIRM",
                    cancel: "CANCEL",
                    notFound: "You don't have any orders."
                },
                sendOffer: {
                    title: "THERE IS NO PENDIND ORDER FOR",
                    sendAOffer: "SEND A OFFER",
                    priceInUsd: "Price in US dollars",
                    description: "Add a description or detail of you proposition",
                    sendBtn: "SEND PROPOSITION",
                    cancel: "CANCEL",
                    accept: "ACCEPT",
                    decline: "DECLINE",
                    accepted: "ACCEPTED",
                    declined: "DECLINED",
                    backToprofile: "BACK TO PROFIL",
                    seeTheProgram: "SEE THE PROGRAM",
                    success: "Offer send successfully!",
                    hasAssignedYou: "has assigned you a program and need your approbation"
                },
                orderComplete: {
                    title: "PROGRAM ASSIGNED",
                    success: "Program assigned successfully to order!",
                    close: "CLOSE",
                },
                refund: {
                    title: "ANNULER ET REMBOURSER",
                    from: "de",
                    cancel: "ANNULER",
                    line1: "Vous avez decidé de ne pas livrer ou produire",
                    line2: "la commande de programme d’entrainnement.",
                    line3: "Un message et le remboursement lui seront envoyé.",
                    line4: "S.V.P. écrire la raison du refut. Ce message sera joint au courriel qui lui sera envoyé.",
                    confirmRefund: "CONFIRMER LE",
                    confirmRefundLine2: " REMBOURSEMENT"
                },
                inviteCoach: {
                    heading: "INVITE AS COACH",
                    line1: "By inviting {{ name }}",
                    line2: "as your Coach you will provide access",
                    line3: "to your Studiogym profile page:",
                    line4: "Your objective, Workout session information",
                    line5: "Name, Age, Gender, Weigh, Language, Time Zone",
                    button: {
                        confirm: "CONFIRM",
                        cancel: "CANCEL"
                    }
                },
                editPicture: {
                    title: "Picture",
                    label: {
                        chooseFile: "Choose File",
                    },
                    helpText: {
                        image: "Image in square format. Maximum 2000 pixels wide."
                    },
                    button: {
                        save: "SAVE"
                    }
                },
                liveWorkout: {
                    title: "VIDÉO EN DIRECT",
                    label: {
                        bundleTitle: "Bundle Title",
                        bundleHour: "Bundle Hour",
                        bundlePrice: "Bundle Price",
                        pricePerProgram: "Price Per Program",
                        currency: "Currency",
                        description: "Description",
                        visible: "Visible",
                    },
                    helpText: {
                        description: "Maximum 200 characters"
                    },
                    button: {
                        'erase': "Erase",
                        'save': "Save"
                    }
                },
                personalForm: {
                    title: "Personal Details",
                    label: {
                        "name": "Name",
                        "en": "English",
                        "fr": "French",
                        "title": "Title",
                        "language": "Language",
                        "country": "Country",
                        "timeZone": "Time Zone",
                        "profession": "Profession",
                        "specialities": "Specialities",
                        "qualifications": "Qualifications",
                    },
                    placeholder: {
                        other: "Other"
                    },
                    button: {
                        save: "Save"
                    }
                },
                presentationForm: {
                    title: "Presentation",
                    label: {
                        chooseFile: "Choose File",
                        picture: "Picture",
                        video: "URL",
                        description: "Text",
                    },
                    helpText: {
                        picture: "Image in landscape orientation. Maximum 2000 pixels wide.",
                        video1: "Video URLs from YouTube and Vimeo are supported.",
                        video2: "Files from your computer or device cannot be imported directly.",
                        description: 'Maximum 500 characters'
                    },
                    button: {
                        save: "SAVE"
                    }
                },
                program: {
                    title: "PERSONNALISED PROGRAM",
                    label: {
                        bundleTitle: "Sub Title",
                        pricePerProgram: "Price Per Program",
                        currency: "Currency",
                        description: "Description",
                        visible: "Visible",
                    },
                    helpText: {
                        description: "Maximum 200 characters"
                    },
                    button: {
                        'erase': "Erase",
                        'save': "Save"
                    }
                },
                socialForm: {
                    title: "Social",
                    button: {
                        save: "SAVE"
                    }
                }
            },
            gender: {
                F: "Women",
                M: "Men",
                A: "For all"
            }
        })
    };

    return translations;
};

app.config(function ($translateProvider) {
    const messages = getMessages();
    $translateProvider.translations('en', messages.en);
    $translateProvider.translations('fr', messages.fr);
    $translateProvider.preferredLanguage('en');
});
